import { authorPath, formatRelativeTime, topicPath } from "@/lib/userUtils";
import { ArticlesForCardQuery } from "@/types/generated";
import Link from "next/link";
import React from "react";

type Props = {
  withCategory?: boolean;
  withTime?: boolean;
  article: ArticlesForCardQuery["articles"][number];
};

export default function AuthorTag({ withCategory, withTime, article }: Props) {
  if (withTime) {
    return (
      <span className="text-xs text-neutral-600 dark:text-neutral-400">
        
        <Link
          href={authorPath(article?.author?.slug)}
          className="font-bold text-neutral-700 dark:text-neutral-300 capitalize"
        >
          {article?.author?.name || article?.author?.username}
        </Link>
        {" | "}
        {formatRelativeTime(article?.articlePublishedAt)}
      </span>
    );
  } else if (withCategory) {
    return (
      <span className="text-xs text-neutral-600 dark:text-neutral-400">
        
        <Link
          href={authorPath(article?.author?.slug)}
          className="font-bold text-neutral-700 dark:text-neutral-300 capitalize"
        >
          {article?.author?.name || article?.author?.username}
        </Link>{" "}
        In{" "}
        {article?.categories?.map((category) => {
          return (
            <Link
              href={topicPath(category?.slug)}
              className="text-neutral-700 dark:text-neutral-300 hover:underline font-bold"
              key={category?.documentId}
            >
              {category?.name}
            </Link>
          );
        })}
      </span>
    );
  } else {
    return (
      <span className="text-xs text-neutral-600 dark:text-neutral-400">
        
        <Link
          href={authorPath(article?.author?.slug)}
          className="font-bold text-neutral-700 dark:text-neutral-300 capitalize"
        >
          {article?.author?.name || article?.author?.username}
        </Link>{" "}
      </span>
    );
  }
}
